import { useState } from "react";
import {
  FaBars,
  FaTimes,
  FaPlus,
  FaUserPlus,
  FaArrowRight,
  FaUsers,
} from "react-icons/fa";
import { Button } from "./ui/button.tsx";
import { useNavigate } from "react-router-dom";
import useUserStore from "../stores/user.store.ts";
import { UserTypeEnum } from "@ns/types";
import { useMutation } from "@tanstack/react-query";
import { api } from "../api/custom-api.ts";
import { removeSession } from "../api/token-helper.ts";
import { MdLogout } from "react-icons/md";

export const HeaderComponent = () => {
  const navigate = useNavigate();
  const { user } = useUserStore();
  const [menuOpen, setMenuOpen] = useState(false);

  const { setUser } = useUserStore();

  const { mutate } = useMutation({
    mutationFn: () => api.auth.postAuthLogout(),
    onSuccess: () => {
      setUser(null);
      removeSession();
      navigate("/");
    },
  });

  return (
    <div className="grid-area-Header p-2 z-30 bg-[#334155] min-h-[4rem] fixed top-0 left-0 right-0 flex items-center justify-between box-border">
      {/* Logo on the left */}
      <div>
        <img
          src="/assets/radic.webp"
          className="w-[8rem] h-[50px]"
          alt="Logo"
        />
      </div>
      {/* Burger Menu Button on the right */}
      <div className="flex items-center">
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="text-white text-2xl"
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
      {/* Mobile & Desktop Menu */}
      {menuOpen && (
        <div className="absolute top-[4.25rem] right-0 w-full bg-[#334155] flex flex-col p-4 space-y-2">
          {user?.type === UserTypeEnum.WAREHOUSE_MANAGER && (
            <Button
              onClick={() => {
                navigate("/codebook");
                setMenuOpen(false);
              }}
            >
              <FaPlus /> Dodaj materijal u šifarnik
            </Button>
          )}
          {user?.type === UserTypeEnum.WAREHOUSE_MANAGER && (
            <Button
              onClick={() => {
                navigate("/warehouse");
                setMenuOpen(false);
              }}
            >
              <FaPlus /> Dodaj materijal na lager
            </Button>
          )}
          {user?.type === UserTypeEnum.WAREHOUSE_MANAGER && (
            <Button
              onClick={() => {
                navigate("/user");
                setMenuOpen(false);
              }}
            >
              <FaUserPlus /> Kreiraj korisnika
            </Button>
          )}
          {user?.type === UserTypeEnum.WAREHOUSE_MANAGER && (
            <Button
              onClick={() => {
                navigate("/warehouses");
                setMenuOpen(false);
              }}
            >
              <FaArrowRight /> Lager
            </Button>
          )}
          {user?.type === UserTypeEnum.WAREHOUSE_MANAGER && (
            <Button
              onClick={() => {
                navigate("/codebooks");
                setMenuOpen(false);
              }}
            >
              <FaArrowRight /> Šifarnik
            </Button>
          )}
          {user?.type === UserTypeEnum.WAREHOUSE_MANAGER && (
            <Button
              onClick={() => {
                navigate("/users");
                setMenuOpen(false);
              }}
            >
              <FaUsers /> Zaposleni
            </Button>
          )}
          <Button onClick={() => mutate()}>
            <MdLogout /> Izloguj se
          </Button>
        </div>
      )}
    </div>
  );
};
